import { Country } from '@dreryk/address-common-api';

import {
   Bean,
   commonTranslationKeys,
   createTranslatedText,
   FieldControllerProps,
   getCurrentLocale,
   ValidationRules,
} from '@dreryk/react-common';
import { Select, StyledMaxWidth, useSelectContext } from '@dreryk/react-components';

import { personalDataTranslationKeys } from '../../../translations';
import { countryIsoCodeGetter, createCountryFilter } from '../../common.utils';

const VALIDATION_RULES: ValidationRules<Bean> = {
   required: true,
};

const getCountryLabel = (item?: Country): string => item?.getName(getCurrentLocale()) ?? '';

const countries = Country.searchAll(getCurrentLocale());
const CountriesList = (): JSX.Element => {
   const { searchText } = useSelectContext();
   const filteredCountries = countries.filter(createCountryFilter(searchText));
   if (!filteredCountries.length) {
      return <Select.NoItems testId={'noCountries'} />;
   }
   return (
      <Select.List items={filteredCountries} keyExtractor={countryIsoCodeGetter}>
         {(country: Country) => (
            <Select.Item<Country>
               item={country}
               testId={countryIsoCodeGetter(country)}
               label={<Select.Highlight node={createTranslatedText(getCountryLabel(country))} />}
            />
         )}
      </Select.List>
   );
};

type PassportCountryFieldProps = FieldControllerProps<'passportCountry', Country | null>;

export const PassportCountryField = (props: PassportCountryFieldProps): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={308}>
         <Select<Country>
            testId={'passportCountry'}
            triggerLabelExtractor={getCountryLabel}
            controller={props.register('passportCountry', VALIDATION_RULES)}
            defaultValue={null}
            label={personalDataTranslationKeys.passportCountry.label}
            placeholder={commonTranslationKeys.choose}
            maxHeight={190}
            searchInputEnabled
         >
            <CountriesList />
         </Select>
      </StyledMaxWidth>
   );
};
